<!--
 * @Description: 特材运输清单
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-01-09 14:57:25
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <!-- 导航 -->
      <div class="tabtop">
        <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
          <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
          <div v-if=" currenindex !== item.id && currenindex !== index + 1 && index !== 3 " class="hr"></div>
        </div>
      </div>
      <el-main style="display: flex">
        <div style="width: 100%">
          <div>
            <div class="search">
              <div>
                <span style="display: inline-block; margin-bottom: 10px" placeholder="请选择">
                  <span style="margin-right: 12px">站点</span>
                  <el-cascader ref="stationIdList" v-model="stationIdList" :options="siteIdListTree" :show-all-levels="false" @change="tableParam.stationId = $refs.stationIdList.getCheckedNodes()[0].value"></el-cascader>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">司机</span>
                  <el-input v-model="tableParam.driver" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">车牌号</span>
                  <el-input v-model="tableParam.carNo" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">特材成品名</span>
                  <el-input v-model="tableParam.productName" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">特材成品类型</span>
                  <el-input v-model="tableParam.productType" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
              </div>
              <div>
                <span>
                  <span style="margin-right: 12px">皮重时间段</span>
                  <el-date-picker
                    v-model="tableParam.timeArr"
                    style="height: 36px"
                    type="datetimerange"
                    unlink-panels
                    align="right"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['12:00:00', '08:00:00']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.dataStatus" style="width: 150px" placeholder="请选择" clearable>
                    <el-option :key="0" label="待出货" :value="0"> </el-option>
                    <el-option :key="1" label="待收货" :value="1"> </el-option>
                    <el-option :key="2" label="已收货" :value="2"> </el-option>
                    <el-option :key="3" label="已入库" :value="3"> </el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </div>
          <div class="hr"></div>
          <div class="card" style="padding-top: 10px">
            <div class="card_nav">
              <div>
                <el-button v-if="currenindex == 2" size="small" class="bottom_one" @click="selectFromDate()">审核</el-button>
                <el-button v-if="currenindex == 3" size="small" class="bottom_two" @click="cancelExamine()">取消审核</el-button>
              </div>
              <div>
                <el-link :underline="false" @click="Download()">
                  <span class="el-icon--left"><i class="iconfont iconicon_button_export1"></i></span>
                  导出
                </el-link>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="50" :selectable="checkSelect"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0">待出货</span>
                        <span v-else-if="scope.row.dataStatus == 1">待收货</span>
                        <span v-else-if="scope.row.dataStatus == 2">已收货</span>
                        <span v-else-if="scope.row.dataStatus == 3">已完成</span>
                      </span>
                      <span v-else-if="item.label == '审核量(吨)'" class="auditVolume">
                        <el-input v-model="scope.row.auditVolume" :disabled="currenindex != 2" style="width: 80px; color: red"  clearable @change="auditVolumeFun(scope.row)" ></el-input>
                      </span>
                      <span v-else-if="item.label == '操作'" class="auditVolume">
                        <el-button v-if="currenindex == 2 && scope.row.secondTime" size="mini" class="bottom_one" @click="writeOff(scope.row)">冲销</el-button>
                        <el-button v-if="currenindex == 1" size="mini" class="bottom_one" style="margin-left: 10px" @click="deleteGoods(scope.row)">删除</el-button>
                        <el-button v-if="currenindex == 1" size="mini" class="bottom_one" style="margin-left: 10px" @click="AddAgainGoods(scope.row)">补录</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
            <div class="card_bottom">
              <div class="card_bottom_left">
                <div class="top_page_totle">总共{{ total }}条</div>
                <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
              </div>
              <div>
                <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <!-- 补录 -->
    <el-dialog v-dialogDrag :visible.sync="addAgainDialog" width="50rem" :close-on-click-modal="false" :before-close="resetAgainDialog">
      <span slot="title" class="dialog-title">补录</span>
      <div class="dialoginfo">
        <el-form ref="fromDateAgain" :inline="true" :model="fromDateAgain" label-width="110px">
          <el-form-item prop="station">
            <span slot="label">站点</span>
            <el-input v-model="fromDateAgain.station" disabled style="width: 200px" clearable />
          </el-form-item>
          <el-form-item prop="productName">
            <span slot="label">成品名称</span>
            <el-input v-model="fromDateAgain.productName" disabled style="width: 200px" clearable  />
          </el-form-item>
          <el-form-item prop="productType">
            <span slot="label">成品型号</span>
            <el-input v-model="fromDateAgain.productType" disabled style="width: 200px" clearable  />
          </el-form-item>
          <el-form-item prop="carNo">
            <span slot="label">车牌号</span>
            <el-input v-model="fromDateAgain.carNo" disabled style="width: 200px" clearable  />
          </el-form-item>
          <el-row>
            <el-form-item prop="firstTime">
              <span slot="label">一次过磅时间</span>
              <el-date-picker v-model="fromDateAgain.firstTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item prop="firstWeighing">
              <span slot="label">一次过磅量</span>
              <el-input v-model="fromDateAgain.firstWeighing"  style="width: 200px" clearable  />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item prop="secondTime">
               <span slot="label">二次过磅时间</span>
               <el-date-picker v-model="fromDateAgain.secondTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
             </el-form-item>
             <el-form-item prop="secondWeighing">
               <span slot="label">二次过磅量</span>
               <el-input v-model="fromDateAgain.secondWeighing"  style="width: 200px" clearable  />
             </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetAgainDialog">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveAgainList()">确 定</el-button>
      </span>
    </el-dialog>
      <!-- 冲销 -->
      <el-dialog v-dialogDrag :visible.sync="writeOffDig" width="580px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title"> 冲销 </span>
        <div class="dialoginfo">
          <el-form ref="reffromDate" :inline="true" :model="fromDate1" label-width="110px" hide-required-asterisk>
            <el-form-item>
              <span slot="label">冲销备注</span>
              <el-input v-model="fromDate1.remark" :rows="5" resize="none" style="width: 320px" type="textarea" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="writeOffDig = false">取 消</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="saveWriteOff()">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, auditConsiment,additionalRecording, cancelAuditConsiment, backWeight, deleteTask } from "@/api/smart/specialmaterial/shiplist.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      stationIdList: [],
      siteIdListTree: [],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      pagesType: 0,
      /*表格数据*/
      table: [
        { label: "运输编号", width: "auto", prop: "code", status: true,},
        { label: "站点", width: "auto", prop: "station", status: true },
        { label: "需求主体", width: "auto", prop: "neddSubject", status: true },
        { label: "特材成品名称", width: "auto", prop: "productName", status: true,},
        { label: "成品型号", width: "auto", prop: "productType", status: true },
        { label: "需求量(吨)", width: "120", prop: "needNum", status: true },
        { label: "审核量(吨)", width: "120", prop: "auditVolume", status: true },
        { label: "出货量(吨)", width: "120", prop: "shipment", status: true },
        { label: "第一次过磅量(吨)", width: "120", prop: "firstWeighing", status: true },
        { label: "第二次过磅量(吨)", width: "120", prop: "secondWeighing", status: true },
        { label: "第一次过磅时间", width: "120", prop: "firstTime", status: true },
        { label: "第二次过磅时间", width: "120", prop: "secondTime", status: true },
        { label: "收货量(吨)", width: "120", prop: "recNum", status: true },
        { label: "入库量(吨)", width: "120", prop: "receipt", status: true },
        { label: "需求时间", width: "120", prop: "needTime", status: true },
        { label: "计划交货时间", width: "120", prop: "planTime", status: true },
        { label: "皮重时间", width: "120", prop: "secondTime", status: true },
        { label: "司机", width: "120", prop: "driver", status: true },
        { label: "车牌号", width: "120", prop: "carNo", status: true },
        { label: "状态", width: "120", prop: "dataStatus", status: true },
        { label: "结算状态", width: "120", prop: "settleStatusMession", status: true },
        { label: "操作", width: "200", prop: "", status: true },
      ],
      /**导航栏*/
      navlist: [
        {
          value: "待收货",
          id: 1,
        },
        {
          value: "未审核",
          id: 2,
        },
        {
          value: "已审核",
          id: 3,
        },
        {
          value: "全部",
          id: 4,
        },
      ],
      currenindex: 1,
      selectList: [],
      writeOffDig: false,
      fromDate1: {
        remark: "",
        id: "",
      },
      fromDateAgain: {
        id: "",
        station: "",
        stationId: "",
        productName: "",
        productId: "", 
        productType: "",
        carNo: "", 
        firstWeighing: "",
        firstTime: "",
        secondWeighing: "",
        secondTime: "",
      },
      addAgainDialog:false,
    };
  },
  watch: {
    /**导航切换*/
    currenindex: {
      handler() {
        this.tableParam = this.$options.data().tableParam;
        this.tableParam.dataType = 3;
        this.stationIdList = [];
        if (this.currenindex == 1) {
          this.tableParam.auditStatus = 2;
        }
        if (this.currenindex == 2) {
          this.tableParam.auditStatus = 0;
        }
        if (this.currenindex == 3) {
          this.tableParam.auditStatus = 1;
        }
        if (this.currenindex == 4) {
          this.tableParam.auditStatus = "";
        }
        this.gettableData();
      },
      deep: false,
      immediate: true,
    },
    //皮重时间段
    "tableParam.timeArr"() {
      if (this.tableParam.timeArr) {
        this.tableParam.startTime = this.tableParam.timeArr[0];
        this.tableParam.endTime = this.tableParam.timeArr[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.siteIdListTree = await getUserAutList();
    this.tableParam = {
      ...this.tableParam,
      dataType: 3,
      auditStatus: 2,
    };
    this.gettableData();
  },
  methods: {
    deleteGoods(row) {
      this.$confirm("此操作将永久删除该数据是否确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTask({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功!");
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },
    AddAgainGoods(row){
      this.fromDateAgain.station = row.station
      this.fromDateAgain.stationId = row.stationId
      this.fromDateAgain.id = row.id
      this.fromDateAgain.productName = row.productName
      this.fromDateAgain.productId = row.productId
      this.fromDateAgain.productType = row.productType
      this.fromDateAgain.carNo = row.carNo
      this.fromDateAgain.firstWeighing = row.firstWeighing
      this.fromDateAgain.firstTime = row.firstTime
      this.fromDateAgain.secondWeighing = row.secondWeighing
      this.fromDateAgain.secondTime = row.secondTime
      this.addAgainDialog= true
      console.log(row)
    },
    resetAgainDialog() {
      this.fromDateAgain={
        id: "",
        station: "",
        stationId: "",
        productName: "",
        productId: "", 
        productType: "", 
        carNo: "", 
        firstWeighing: "",
        firstTime: "",
        secondWeighing: "",
        secondTime: "",
      },
      this.addAgainDialog = false;
    },
    saveAgainList(){
      this.$refs.fromDateAgain.validate(valid => {
        if (valid) {
          const secondTime = new Date(this.fromDateAgain.secondTime);
          const firstTime = new Date(this.fromDateAgain.firstTime);
          console.log(this.fromDateAgain)
          if(this.fromDateAgain.secondTime && this.fromDateAgain.firstTime){
            if (secondTime.getTime() > firstTime.getTime()) {
              additionalRecording(this.fromDateAgain).then(res => {
                if (res.code === 1001) {
                  this.$message({
                    message: "操作成功！",
                    type: "success",
                  });
                  this.resetAgainDialog();
                  this.gettableData();
                }
              });
            } else {
             this.$message.warning("第二次过磅时间必须在第一次过磅时间之后!");
            }
          }else{
            additionalRecording(this.fromDateAgain).then(res => {
                if (res.code === 1001) {
                  this.$message({
                    message: "操作成功！",
                    type: "success",
                  });
                  this.resetAgainDialog();
                  this.gettableData();
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    saveWriteOff() {
      backWeight(this.fromDate1).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.gettableData();
          this.writeOffDig = false;
        }
      });
    },
    writeOff(row) {
      this.fromDate1.id = row.id;
      (this.fromDate1.remark = ""), (this.writeOffDig = true);
    },
    auditVolumeFun(row) {
      console.log("----", row);
      this.selectList.forEach(item => {
        if (item.id == row.id) {
          console.log("--item--", item);
          item.auditVolume = row.auditVolume;
          return;
        }
      });
    },
    cancelExamine() {
      if (this.selectList.length > 0) {
        let paramArr = this.selectList.map(item => {
          return item.id;
        });
        cancelAuditConsiment(paramArr).then(res => {
          if (res.code == 1001) {
            if (!res.data) {
              this.$message({
                message: "审核已取消～",
                type: "warning",
              });
              this.gettableData();
            } else {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          } else {
            this.$message({
              message: res.codeMsg,
              type: "warning",
            });
          }
        });
      } else {
        this.$message({ message: "请选择需要取消审核数据！", type: "warning" });
      }
    },
    submitApplyExamine() {
      if (this.selectList.length > 0) {
        let paramArr = this.selectList.map(item => {
          return { id: item.id, auditVolume: item.auditVolume, code: item.code };
        });
        auditConsiment(paramArr).then(res => {
          if (res.code == 1001) {
            if (!res.data) {
              this.$message({
                message: "审核已经提交",
                type: "warning",
              });
              this.gettableData();
            } else {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          } else {
            this.$message({
              message: res.codeMsg,
              type: "warning",
            });
          }
        });
      }
    },
    selectFromDate() {
      if (this.selectList.length > 0) {
        // this.examineDialog = true
        this.$confirm("是否提交当前选中数据进行审核?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.submitApplyExamine();
          })
          .catch(() => {});
      } else {
        this.$message({ message: "请选择需要审核数据！", type: "warning" });
      }
    },
    handleSelectionChange(rows) {
      let itemArr = rows.map(item => {
        if (!item.auditVolume) {
          item.auditVolume = item.recNum == 0 ? item.needNum : item.recNum;
        }
        return item;
      });
      this.selectList = JSON.parse(JSON.stringify(itemArr));
    },
    checkSelect(row) {
      if (this.currenindex == 3) {
        if (row.settleStatusMession == "待结算") {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    /**导航栏切换*/
    choose(pages) {
      this.currenindex = pages;
      console.log(this.currenindex)
    },
    Download() {
      this.$Download("/icps/system/sign/intelligent/materials/shipping/receiveexportList", this.tableParam);
    },
    /*重置数据*/
    init() {
      this.stationIdList = [];
      this.tableParam.stationId = "";
      this.tableParam.driver = "";
      this.tableParam.productName = "";
      this.tableParam.productType = "";
      this.tableParam.dataStatus = "";
      this.tableParam.carNo = "";
      this.tableParam.timeArr = "";
      this.tableParam.dataType = 3;
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.tabtop {
  width: 762px;
}
</style>
<style scoped>
.auditVolume >>> .el-input__inner {
  color: red;
}
</style>
